export default "__VITE_ASSET__CxVApys0__"